import {dsvFormat} from "d3-dsv";

export function streamParser(sample) {
    let csv, header, keys;

    const initializeParser = function(string) {
        const delimeters = [",", ";", "\t"];

        while (delimeters.length) {
            let parsed = dsvFormat(delimeters.shift());
            let rows = parsed.parseRows(string);
            let samplekeys = rows.shift();

            // check if 10 first rows have the same number of cells to check
            // if that the selected delimiter was correct
            if (rows.slice(0, 10).every(function(row) {
                return row.length > 1 && row.length === samplekeys.length;
            })) {
                return parsed;
            }
        }

        throw new Error("Failed to determine dsv format for " + string);
    };

    const parser = function(string) {
        //d3 csv parser doesn't work correctly if
        //the last character is not a line separator
        string = string.trim() + "\n";

        //
        if (!header) {
            const index = string.indexOf("\n") + 1;
            header = string.slice(0, index);
            let _fail = false;

            // try to prevent accidentally parsing json or
            // other "clearly not csv" files as csv
            try {
                JSON.parse(header);
                _fail = true;
            } catch (e) {
                _fail = /[,;\t]/.test(header) !== true;
            }

            if (_fail) {
                throw new Error("doesn't seem to be csv");
            }

            if (index < string.length) {
                return parser(string.slice(index));
            } else {
                return null;
            }
        }

        if (!csv) {
            csv = initializeParser(header + string);
            keys = csv.parseRows(header).shift();
        }

        return csv.parseRows(string, function(d) {
            let item = {};
            keys.forEach(function(key, i) {
                item[key] = d[i];
            });

            return item;
        });
    };

    return {
        parse: parser
    };
}

export function parse(string) {
    return streamParser().parse(string);
}



// WEBPACK FOOTER //
// ./src/lib/csv.js